import { Link } from 'react-router';
import styles from './TitleBanner.module.scss';
import { PAGE_NAVIGATION_GROUPS_NAMES } from 'features/Home/navigationConfig';

interface TitleBannerProps {
  bannerSrc: string;
  logoSrc: string;
  projectName: string;
  bannerTitle: string;
  bannerSubtitle: string;
}

export const TitleBanner = ({ bannerSrc, logoSrc, bannerTitle, bannerSubtitle, projectName }: TitleBannerProps) => {
  return (
    <div className={styles.titleBannerRoot}>
      <img width='1920' height='580' src={bannerSrc} alt={`${projectName} case study banner`} />
      <img width='496' height='430' className={styles.titleBannerLogo} src={logoSrc} alt={`${projectName} logo`} />
      <div className={styles.titleBannerContent}>
        <Link className={styles.titleBannerBackLink} to={`/#${PAGE_NAVIGATION_GROUPS_NAMES.CASE_STUDIES}`}>
          <span>Back</span>
        </Link>
        <div className={styles.titleBannerTextLayout}>
          <h2 className={styles.titleBannerHeading}>{bannerTitle}</h2>
          <p className={styles.titleBannerSubheading}>{bannerSubtitle}</p>
        </div>
      </div>
    </div>
  );
};
